import React from 'react';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { MoreNewsItem }
from '@fuww/library/src/Articles/Sections/MoreNews';
import MoreNewsList from '../../NewsList/Categories/MoreNews';
import MoreNewsCardWithQuery from './MoreNewsCard';
import articlesQuery from '../../../../lib/queries/news/articlesQuery.graphql';
import { featuredCategoryIds } from '../../../../lib/mainCategoryIds';
import { useSiteContext } from '../../../SiteContext';
import useNoCacheOnServerFetchPolicy
from '../../../../lib/useNoCacheOnServerFetchPolicy';
import {
  moreNewsMixedImageConfigurations,
} from '../../../../lib/imageConfigurations';

const errorMessage = 'Error loading news articles...';

const MoreNewsMixedBlock = ({
  variables, showCreatedAt, offset, skip,
}) => {
  const theme = useTheme();
  const { newsboard } = useSiteContext();
  const fetchPolicy = useNoCacheOnServerFetchPolicy();

  const moreNewsVariables = {
    newsboard,
    withoutSummaryAndLabel: false,
    withoutDescriptionAndCreator: false,
    featured: false,
    limit: 1,
    sort: 'CREATED_AT',
    statuses: ['PUBLISHED'],
    categoryIds: featuredCategoryIds,
    imageConfigurations: moreNewsMixedImageConfigurations,
    ...variables,
  };

  return (
    <>
      <MoreNewsItem className="fu-read-more">
        <MoreNewsCardWithQuery
          query={articlesQuery}
          variables={{
            ...moreNewsVariables,
            offset,
          }}
          errorMessage={errorMessage}
          showCreatedAt={showCreatedAt}
          fetchPolicy={fetchPolicy}
          skip={skip}
        />
      </MoreNewsItem>
      <MoreNewsItem
        borderRight={`{1px solid ${theme.colors?.greyLight}`}
        padding="0 24px 0 0"
      >
        <MoreNewsCardWithQuery
          query={articlesQuery}
          variables={{
            ...moreNewsVariables,
            offset: offset + 1,
          }}
          errorMessage={errorMessage}
          showCreatedAt={showCreatedAt}
          fetchPolicy={fetchPolicy}
          skip={skip}
        />
      </MoreNewsItem>
      <MoreNewsItem
        borderRight={`{1px solid ${theme.colors?.greyLight}`}
        padding="0 24px 0 0"
      >
        <MoreNewsList
          showCategory
          noBorderFirstItem
          categoryHeadline={false}
          variables={variables}
          offset={offset + 2}
          limit={3}
          skip={skip}
        />
      </MoreNewsItem>
      <MoreNewsItem>
        <MoreNewsList
          categoryHeadline={false}
          noBorderFirstItem
          variables={variables}
          offset={offset + 5}
          limit={4}
          skip={skip}
        />
      </MoreNewsItem>
    </>
  );
};

MoreNewsMixedBlock.cardinality = 9;

MoreNewsMixedBlock.propTypes = {
  variables: PropTypes.shape({}),
  showCreatedAt: PropTypes.bool,
  offset: PropTypes.number,
  skip: PropTypes.bool,
};

MoreNewsMixedBlock.defaultProps = {
  variables: null,
  showCreatedAt: false,
  offset: 0,
  skip: false,
};

export default MoreNewsMixedBlock;
